import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=4b5e6572&"
import script from "./ProfileCard.vue?vue&type=script&lang=ts&"
export * from "./ProfileCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports